// src/components/Footer.jsx
import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/panelzero-icon.png";
import "./Footer.css";

function Footer() {
  const [email, setEmail] = useState("");
  const year = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (!email) return;
    window.location.href = `mailto:adcheng4@illinois.edu?subject=Updates%20signup&body=${encodeURIComponent(
      `Please keep me posted on PanelZero.\n\nEmail: ${email}`
    )}`;
  };

  return (
    <footer className="bw-footer-modern">
      <div className="bw-footer__container">
        <div className="bw-footer__grid">
          <div className="bw-footer__col bw-footer__col--brand">
            <div className="bw-footer__brand-wrap" onClick={scrollToTop}>
              <img src={logo} alt="PanelZero logo" className="bw-footer__logo" />
              <span className="bw-footer__brandName">PanelZero</span>
            </div>
            <p className="bw-footer__desc">
              AI-powered denial management. Stop rework, recover revenue, and integrate with every major EHR.
            </p>
          </div>

          <div className="bw-footer__col">
            <h5 className="bw-footer__heading">Product</h5>
            <nav className="bw-footer__nav">
              <Link to="/" onClick={scrollToTop}>Home</Link>
              <Link to="/about" onClick={scrollToTop}>About</Link>
              <Link to="/contact" onClick={scrollToTop}>Request demo</Link>
              <a href="/#integrations">EHR Integrations</a>
            </nav>
          </div>

          <div className="bw-footer__col">
            <h5 className="bw-footer__heading">Legal</h5>
            <nav className="bw-footer__nav">
              <Link to="/privacy" onClick={scrollToTop}>Privacy Policy</Link>
              <Link to="/terms" onClick={scrollToTop}>Terms of Service</Link>
              {/* Restore when security@panelzero.com is live:
              <a href="mailto:security@panelzero.com">Report an Issue</a>
              */}
              <a href="mailto:adcheng4@illinois.edu?subject=PanelZero%20issue%20report">Report an Issue</a>
            </nav>
          </div>

          <div className="bw-footer__col bw-footer__col--sub">
            <h5 className="bw-footer__heading">Get Updates</h5>
            <p className="bw-footer__sub-text">
              Quarterly product updates. No spam.
            </p>
            <form className="bw-footer__form" onSubmit={handleSubscribe}>
              <div className="bw-input-wrap">
                <input
                  type="email"
                  className="bw-modern-input"
                  placeholder="you@yourpractice.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  aria-label="Email address"
                  required
                />
                <button type="submit" className="bw-modern-btn" aria-label="Subscribe">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="22" y1="2" x2="11" y2="13"></line>
                    <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                  </svg>
                </button>
              </div>
            </form>
          </div>
        </div>

        <div className="bw-footer__bottom">
          <p className="bw-copyright">© {year} PanelZero, Inc. All rights reserved. HIPAA-aligned. SOC 2 in progress.</p>

          <button onClick={scrollToTop} className="bw-footer__top-btn">
            Back to top
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M18 15l-6-6-6 6"/>
            </svg>
          </button>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
